import { Pagination, Typography } from "antd";
import { useCallback, useState } from "react";
import { useHistory } from "react-router-dom";
import {
	NOTIFICATION_TYPES,
	openNotification,
} from "../Notifications/NotificationsUtils";
import { useTranslation } from "react-i18next";
import { useQuery, useQueryClient } from "react-query";
import { getMentorshipOffers } from "../../utils/reactQueriesConstants";
import useQueryFilters from "../../Hooks/useQueryFilters";
import { Routes } from "../../utils/routes";
import Filters from "../Filters";
import {
	getAllMentorshipPropsals,
	getMentorshipsProposalFilters,
} from "../../Requests/mentorship-requests";
import MentorshipList from "./MentorshipList";
import { useMentorshipListController } from "./MentorshipList.controller";

const MentorshipOffers = (props: any) => {
	const { t } = useTranslation();
	const [pageSize, setPageSize] = useState(10);
	const [currentPage, setCurrentPage] = useState(1);
	const [checkedKeys, setCheckedKeys] = useState([]);
	const [searchTerm, setSearchTerm] = useState("");
	const queryClient = useQueryClient();
	const query = useQueryFilters({});
	const history = useHistory();

	const { state, actions } = useMentorshipListController(props);

	const handleListChange = async (current: number, pageSize: number) => {
		setCurrentPage(() => current);
		setPageSize(() => pageSize);
		await queryClient.invalidateQueries(getMentorshipOffers);
	};

	const openGetErrorNotification = (_error: any) => {
		openNotification(
			t("polijobs.error"),
			t("polijobs.fetchDataError"),
			NOTIFICATION_TYPES.ERROR
		);
	};

	const { data: filters } = useQuery(
		[getMentorshipsProposalFilters],
		() => {
			return getMentorshipsProposalFilters();
		},
		{
			onError: openGetErrorNotification,
			refetchOnWindowFocus: false,
		}
	);

	const { data: offers, isLoading: loadingOffers } = useQuery(
		[getMentorshipOffers, query.filters],
		() => getAllMentorshipPropsals(query.filters),
		{
			onError: openGetErrorNotification,
			refetchOnWindowFocus: false,
		}
	);

	const onUpdate = useCallback(
		(values: { [key: string]: string[] }) => {
			query.update(values, true);
		},
		[query]
	);

	const onPageUpdate = useCallback(
		(page: number, pageSize: number) => {
			query.update({
				page: page.toString(),
				pageSize: pageSize.toString(),
			});
		},
		[query]
	);

	return (
		<div className="px-4 pb-10 flex flex-col relative">
			<Filters
				filters={filters}
				searchFields={[{ name: "searchTerm", label: t("internships.search") }]}
				onUpdate={onUpdate}
				hasSort={false}
			/>

			<div className="flex flex-col gap-10 relative">
				<div className="flex flex-col md:flex-row justify-between items-center">
					<Typography.Title level={3} className="my-0">
						{offers?.totalCount} {t("filtering.results")}
					</Typography.Title>

					{!loadingOffers && (
						<Pagination
							current={Number(query.filters.page) || offers?.page || 1}
							pageSize={Number(query.filters.pageSize) || 12}
							defaultCurrent={offers?.page}
							total={offers?.totalCount}
							onChange={onPageUpdate}
							pageSizeOptions={[12, 24, 48, 96]}
							defaultPageSize={12}
						/>
					)}
				</div>
				<MentorshipList
					data={offers}
					actions={actions}
					state={state}
					checkedKeys={[]}
					loading={loadingOffers}
					location={props.location}
					currentPage={currentPage}
					pageSize={pageSize}
					searchTerm={""}
					handleListChange={handleListChange}
				/>
			</div>
		</div>
	);
};

export default MentorshipOffers;
